import Swal from "sweetalert2";

export interface StrongDeleteTexts {
  title: string;
  text: string;
  prompt: string;
  word: string;
  mismatch: string;
  confirm: string;
  cancel: string;
}

export async function confirmStrongDelete(
  texts: StrongDeleteTexts
): Promise<boolean> {
  const result = await Swal.fire({
    icon: "warning",
    title: texts.title,
    html: `<p style="margin-bottom:0.75rem">${texts.text}</p><p style="font-weight:600">${texts.prompt}</p>`,
    input: "text",
    inputPlaceholder: texts.word,
    showCancelButton: true,
    confirmButtonText: texts.confirm,
    cancelButtonText: texts.cancel,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    allowOutsideClick: false,
    preConfirm: (value: string) => {
      if ((value || "").trim() !== texts.word) {
        Swal.showValidationMessage(texts.mismatch);
        return false;
      }
      return true;
    },
  });
  return result.isConfirmed;
}
